import { render, staticRenderFns } from "./animatedBrochure.vue?vue&type=template&id=de32b84c&"
import script from "./animatedBrochure.vue?vue&type=script&lang=js&"
export * from "./animatedBrochure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports